module.exports = __webpack_public_path__ + "img/icon-submit.f665d7b0.png";